export const INSTALL_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/yolk-sales-call-assistant/mlleoaegihnmejbeamoapbgpelchaegd";

// TODO: replace with actual typeform URL when ready
export const BOOK_DEMO_URL = "#";
